import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { TeaProperties as TeaProperty } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { TeaProperties } from '@app/api/marketplace/models';

@Component({
  selector: 'app-tea-properties-subform',
  styleUrls: ['./tea-properties-subform.component.scss'],
  templateUrl: './tea-properties-subform.component.html',
})
export class TeaPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.TEA_PROPERTIES';

  format = TeaProperty.FormatEnum;
  preparationProcedure = TeaProperty.PreparationProcedureEnum;
  type = TeaProperty.TypeEnum;

  static buildForm(fb: FormBuilder, data?: TeaProperties) {
    return fb.group({
      format: [data?.format, Validators.required],
      preparationProcedure: [data?.preparationProcedure, Validators.required],
      type: [data?.type, Validators.required],
    });
  }
}
